import { Card, Group, Select, Stack, Text, TextInput } from '@mantine/core';
import { useClientFormContext } from '../ClientPersonalSection';
import { DateInput, type DateValue } from '@mantine/dates';
import dayjs from 'dayjs';
import { dateFormat } from '@/index';
import useSWR from 'swr';
import { type Mapping } from '@/schemas/API/GET/mapping/response';
import { getFetcher } from '@/api/fetchers';
import { MappingToComboBoxItem } from '@/schemas/converters/mappingShemasConverter';

export const PersonInfoCard = (): JSX.Element => {
  const form = useClientFormContext();

  const { data: sexMap } = useSWR<Mapping>('mappings/sexes', getFetcher);

  return (
    <Card padding="md" radius="md" withBorder>
      <Text fw={700} size="large">
        Osobní informace
      </Text>

      <Stack gap="sm" className="mt-3">
        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="Titul"
          {...form.getInputProps('title')}
        />

        <Group justify="space-between" grow align="start">
          <TextInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Jméno"
            {...form.getInputProps('firstName')}
          />
          <TextInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Příjmení"
            {...form.getInputProps('lastName')}
          />
        </Group>

        <Select
          variant="filled"
          radius="md"
          label="Pohlaví"
          data-testid="Pohlaví"
          data={sexMap ? MappingToComboBoxItem(sexMap) : []}
          defaultValue={sexMap?.[form.values.sex]}
          {...form.getInputProps('sex')}
        />

        <DateInput
          variant="filled"
          radius="md"
          label="Datum narození"
          placeholder="note"
          valueFormat={dateFormat}
          value={dayjs(form.values.birthdate, dateFormat).toDate()}
          onChange={(d: DateValue) => {
            const date: string = dayjs(d).format(dateFormat);
            form.setFieldValue('birthdate', date);
          }}
          error={form.getInputProps('birthdate').error}
          locale="cs"
        />
      </Stack>
    </Card>
  );
};
